module.exports = __webpack_public_path__ + "static/media/12.db33d317.jpg";